import React, { useMemo, useState } from "react";
import { authRoutes, barePages, cmsPages, protectedPages } from "./router.link";
import { Outlet, Route, Routes } from "react-router-dom";
import AuthHeader from "../../components/authHeader";
import AuthFooter from "../../components/authFooter";
import Header from "../../components/header";
import Footer from "../../components/footer";
import RouteProtected from "./RouteProtected";
import RootRedirect from "./RootRedirect";
import { getStorageItem } from "../../services/storage.service";
import { useSelector } from "react-redux";


const AllRoutes = () => {
  const token = useSelector((state: any) => state.user.token);
  const has_subscription = useSelector((state: any) => state.user?.has_subscription);

  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const onToggleSidebar = () => { setIsSidebarOpen(prevState => !prevState) };


  // Default layout
  const MainLayout = () => (
    <>
      <Header onToggleSidebar={onToggleSidebar} isSidebarOpen={isSidebarOpen} />
      <Outlet context={{ isSidebarOpen, onToggleSidebar }} />
      <Footer />
      {/* <Loader/> */}
    </>
  );

  // Auth layout
  const AuthLayout = () => (
    <>
      <AuthHeader />
      <Outlet />
      <AuthFooter />
    </>
  );

  // 3. Choose the right layout for CMS pages
  const CmsLayout = useMemo(() => {
    return (token && has_subscription) ? MainLayout : AuthLayout;
  }, [token, has_subscription]);

  return (
    <>

      <Routes>
        {/* 0. Root → decide where to go */}
        <Route index element={<RootRedirect />} />

        {/* ---------------------------------------------------------- */}
        {/* 1. CMS pages – appear under BOTH layouts */}
        {/* ---------------------------------------------------------- */}
        <Route element={<CmsLayout />}>
          {cmsPages.map((r, i) => (
            <Route
              key={`cms-${i}`}
              path={r.path}
              element={
                token ? (
                  // logged-in → protect (optional, you can remove if you want)
                  <RouteProtected>{r.element}</RouteProtected>
                ) : (
                  r.element
                )
              }
            />
          ))}
        </Route>

        {/* 2. Auth-only pages – always under AuthLayout */}
        <Route element={<AuthLayout />}>
          {authRoutes.map((r, i) => (
            <Route key={`auth-${i}`} path={r.path} element={r.element} />
          ))}
        </Route>

        {/* 3. Protected pages – need token + main header */}
        <Route element={<MainLayout />}>
          {protectedPages.map((r, i) => (
            <Route
              key={`prot-${i}`}
              path={r.path}
              element={<RouteProtected>{r.element}</RouteProtected>}
            />
          ))}
        </Route>

        {/* 4. Bare pages – no wrapper */}
        {barePages.map((r, i) => (
          <Route key={`bare-${i}`} path={r.path} element={r.element} />
        ))}

      </Routes>

    </>
  );
};
export default AllRoutes;
